import { c as _c } from "react/compiler-runtime";
import { withBasePath } from "@repo/design-system/lib/base-path";
import { geoapifyToGeoLocation } from "@repo/design-system/utils/geoapify/geoapify";
import { getUserLocation } from "@repo/design-system/utils/geoapify/utils";
import { useMutation } from "@tanstack/react-query";
interface RadiusOption {
  label: string;
  value: number;
}
interface UseLocateUserProps {
  locale: string;
  onSuccess: (location: GeoLocationData) => void;
}
interface GeoLocationData {
  lat: number;
  lng: number;
  name: string;
  placeId?: string;
}

// Utility function for radius options
export function createRadiusOptions(text: Record<"country" | "city" | "default" | "unit", string>, resultType?: string): RadiusOption[] {
  const getBoundariesTranslation = (result?: string): string => {
    switch (result) {
      case "country":
        return text.country;
      case "city":
        return text.city;
      default:
        return text.default;
    }
  };
  return [{
    value: 0,
    label: getBoundariesTranslation(resultType)
  }, {
    value: 5000,
    label: `5 ${text.unit}`
  }, {
    value: 25_000,
    label: `25 ${text.unit}`
  }, {
    value: 50_000,
    label: `50 ${text.unit}`
  }, {
    value: 100_000,
    label: `100 ${text.unit}`
  }, {
    value: 300_000,
    label: `300 ${text.unit}`
  }];
}
export function useLocateUser(t0) {
  const $ = _c(5);
  const {
    locale,
    onSuccess
  } = t0;
  let t1;
  if ($[0] !== locale) {
    t1 = async () => {
      const position = await getUserLocation();
      if (!(position.coords.latitude && position.coords.longitude)) {
        throw new Error("location_failed");
      }
      const lat = position.coords.latitude;
      const lng = position.coords.longitude;
      let name = "";
      let placeId;
      const response = await fetch(withBasePath("/api/filter/geo"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          type: "geo_reverse",
          lat,
          lng,
          lang: locale
        })
      });
      if (!response.ok) {
        throw new Error("location_failed");
      }
      const data = await response.json();
      if (data.features?.[0]) {
        name = geoapifyToGeoLocation(data.features[0]).name;
        placeId = data.features[0].properties.place_id;
      }
      return {
        name,
        lat,
        lng,
        placeId
      };
    };
    $[0] = locale;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onSuccess || $[3] !== t1) {
    t2 = {
      mutationFn: t1,
      onSuccess
    };
    $[2] = onSuccess;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return useMutation(t2);
}